<script setup lang="ts">
import { computed } from "vue";
import DRBtnIcon from "../UI/DRBtnIcon.vue";
import { useDeleteLegend, useDuplicateLegend } from "@/stores/queries";
import type { Legend } from "@/types";
import { useRouter } from "vue-router";
import DRConfirmPopup from "../UI/feedbacks/DRConfirmPopup.vue";

const props = defineProps<{
  legend: Legend;
}>();

const id = computed(() => props.legend.id);

const router = useRouter();
const handleUpdate = () => {
  router.push({
    name: "legend-update",
    params: { id: props.legend.id },
  });
};

const { mutateAsync: onDelete, isPending: isDeleting } = useDeleteLegend(id);
const { mutateAsync: onDuplicate, isPending: isDuplicating } =
  useDuplicateLegend(id);
</script>

<template>
  <div class="col-auto d-flex gap-2 align-items-center">
    <DRBtnIcon
      icon="bi-sliders"
      variant="outline"
      @click="handleUpdate"
      :size="30"
    />
    <DRBtnIcon
      icon="bi-copy"
      :disabled="isDuplicating"
      variant="outline"
      @click="onDuplicate"
      :size="30"
    />
    <DRConfirmPopup
      :title="$t('dashboard:legends.confirmDelete')"
      @confirm="onDelete"
    >
      <DRBtnIcon
        icon="bi-trash3"
        :disabled="isDeleting"
        variant="outline-danger"
        :size="30"
      />
    </DRConfirmPopup>
  </div>
</template>

<style lang="scss" scoped>
i {
  font-size: 1.5rem;
}
</style>
